<script setup>
import { onMounted, onUnmounted } from 'vue';

// Props.
defineProps({
  hideFooter: {
    type: Boolean,
    default: false,
  },
});

// Model value.
const model = defineModel();

// Methods.
const closeOnEscape = (e) => {
  if (e.key === 'Escape') {
    model.value = false;
  }
};

onMounted(() => {
  window.addEventListener('keydown', closeOnEscape);
});

onUnmounted(() => {
  window.removeEventListener('keydown', closeOnEscape);
});
</script>

<template>
  <div class="dialog__backdrop-overlay" @click="model = false"></div>
  <div class="dialog">
    <div class="dialog__header">
      <slot name="header"></slot>
      <i class="fa-solid fa-xmark" @click="model = false"></i>
    </div>
    <div class="dialog__content">
      <slot name="content"></slot>
    </div>
    <div v-if="!hideFooter" class="dialog__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
